module.exports = __webpack_public_path__ + "static/media/testfile_ps_lr.7dd63129.zip";